import { keyframes, styled } from 'style'

const loading = keyframes({
  '100%': { transform: 'translateX(100%)' },
})

const SkeletonStyled = styled('div', {
  position: 'relative',
  backgroundColor: '$bg3',
  overflow: 'hidden',
  borderRadius: '$lg',

  '&:after': {
    content: '',
    position: 'absolute',
    inset: 0,
    backgroundImage: `linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.1) 20%,
      rgba(255, 255, 255, 0.3) 60%,
      rgba(255, 255, 255, 0)
    )`,
    transform: 'translateX(-100%)',
    animation: `${loading} 3s infinite`,
  },

  '& *': {
    opacity: 0,
  },

  '.dark &': {
    opacity: 0.5,
  },

  variants: {
    round: {
      true: {
        borderRadius: '$round',
      },
    },
  },
})

export default SkeletonStyled
